function selectedModifierSummary(part:string):string {
  const match=part.match(/^([^：:]+)[：:]\s*(.+)$/u);
  if(!match)return part;
  const key=match[1]!.trim(),raw=match[2]!.trim();
  // These selected drink values are unambiguous on their own. Keep the stored group names
  // intact for editing, validation and print consumers that request preserveModifierGroups.
  if(/(?:甜度|糖度|冰量|冰涼)$/.test(key))return raw;
  // Structural meal choices, drink configuration and free notes keep their context.
  if(/備註|要求|主食|小食|飲品|飲料|飯底|主餐|餐點|主菜|冰量|甜度|糖度|辣度|溫度/.test(key)||/^(?:選擇)?飯[團糰]$/.test(key))return part;
  const addon=/加料|加配|配料|辣油/.test(key);
  const values=raw.split('、').map(value=>addon?value.replace(/^(?:加)?秘[製制]辣油(?=\s*(?:[+＋−-]|\(|$))/u,'加辣油'):value);
  const isOwnAction=(value:string)=>{
    const name=value.replace(/\s*(?:[+＋−-]\s*(?:HK\$|\$)?\d+(?:\.\d{1,2})?|\([+＋−-]?(?:HK\$|\$)?\d+(?:\.\d{1,2})?\))\s*$/u,'').trim();
    const action=name.match(/^(?:走|少|多|加|雙倍)(.+)$/u);
    return Boolean(action&&(addon||key.includes(action[1]!)));
  };
  return values.every(isOwnAction)?values.join('、'):part;
}

/** Display copy only: hide generated links and repeated selected-modifier headings. */
export function orderLineDetailForDisplay(detail?:string,options?:{preserveModifierGroups?:boolean;optionNames?:Readonly<Record<string,string>>}):string|undefined {
  const parts=String(detail??'').split(/\s*[·｜]\s*/u);
  const visible:string[]=[];
  for(let index=0;index<parts.length;index++){
    const part=parts[index]!.trim().replace(/^每份(?:配搭|搭配)[：:]\s*/u,'');
    // Legacy drink links carry the parent name in the following segment.
    if(/^配餐[：:]/.test(part)){index++;continue;}
    if(/^(?:餐組|套餐配對|套餐|角色)[：:]/.test(part)||/^[（(]?主食餐\s*\d*[）)]?$/.test(part))continue;
    if(part){
      const selected=part.match(/^([^：:]+)([：:]\s*)(.+)$/u);
      const shown=options?.optionNames&&selected&&!/備註|要求/.test(selected[1])?selected[1]+selected[2]+selected[3].split('、').map(value=>{const match=value.trim().match(/^(.+?)(\s+[+＋−-]\s*(?:HK\$|\$)?\d+(?:\.\d{1,2})?)?$/u);return match?(options.optionNames![JSON.stringify([selected[1].trim(),match[1]])]??match[1])+(match[2]??''):value;}).join('、'):part;
      visible.push(options?.preserveModifierGroups?shown:selectedModifierSummary(shown));
    }
  }
  return visible.join(' · ')||undefined;
}
